module.exports = __webpack_public_path__ + "img/empty-barista.d177ccd.svg";